import { Grow, Typography } from '@mui/material';

import { Flex } from 'components/ui/flex';

const CheckoutThemePreviewV2 = ({
  logo,
  primaryColor,
  textColor,
  buttonColor,
  buttonTextColor,
  bgImage,
  bgMobileImage,
  onClose
}: {
  logo: string;
  primaryColor: string;
  textColor: string;
  buttonColor: string;
  buttonTextColor: string;
  bgImage: string;
  bgMobileImage: string;
  onClose: () => void;
}) => {
  return (
    <Flex
      justify="center"
      align="center"
      onClick={() => onClose()}
      className="absolute top-0 left-0 z-[9999] w-screen h-screen bg-black/75"
      style={{ fontFamily: "'Montserrat', sans-serif" }}
    >
      <Grow in>
        <Flex
          direction="row"
          justify="center"
          align="start"
          className="gap-16"
        >
          <Flex align="center" className="gap-4">
            <Typography variant="h6" color={'white'} fontWeight={400}>
              Desktop
            </Typography>
            <Flex
              direction="row"
              className="w-[740px] h-[740px] bg-[whitesmoke] rounded-[15px]"
            >
              <Flex
                className="w-[296px] gap-4 px-8 py-4 rounded-l-[15px]"
                style={{
                  background: primaryColor,
                  backgroundImage: `url(${bgImage})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center top'
                }}
              >
                <Flex align="start" className="h-[68px] mt-4">
                  <img
                    src={logo}
                    alt="logo"
                    style={{ height: '48px', objectFit: 'contain' }}
                  />
                </Flex>
                <Flex>
                  <Typography
                    variant="h6"
                    color={textColor}
                    sx={{
                      fontSize: '14px',
                      fontWeight: 500,
                      fontFamily: "'Montserrat', sans-serif"
                    }}
                  >
                    Crazy Pack
                  </Typography>
                  <Typography
                    variant="h6"
                    color={textColor}
                    sx={{
                      fontSize: '24px',
                      fontWeight: 600,
                      fontFamily: "'Montserrat', sans-serif"
                    }}
                  >
                    $99.99
                  </Typography>
                </Flex>
                <Flex className="gap-4">
                  <hr
                    style={{
                      marginTop: '-8px',
                      width: '232px',
                      border: '1px solid white'
                    }}
                  />
                  <Flex direction="row" className="gap-3">
                    <img
                      src="https://media-dev.appcharge.com/media/product-3.png"
                      alt=""
                      style={{
                        width: '48px',
                        height: '48px'
                      }}
                    />
                    <Flex justify="center" className="gap-1">
                      <span
                        style={{
                          fontSize: '12px',
                          fontWeight: 400,
                          fontFamily: "'Montserrat', sans-serif",
                          color: textColor
                        }}
                      >
                        Coins
                      </span>
                      <span
                        style={{
                          fontSize: '16px',
                          fontWeight: 600,
                          fontFamily: "'Montserrat', sans-serif",
                          color: textColor
                        }}
                      >
                        6580
                      </span>
                    </Flex>
                  </Flex>
                  <Flex direction="row" className="gap-3">
                    <img
                      src="https://media-dev.appcharge.com/media/bills.png"
                      alt=""
                      style={{
                        width: '48px',
                        height: '48px'
                      }}
                    />
                    <Flex justify="center" className="gap-1">
                      <span
                        style={{
                          fontSize: '12px',
                          fontWeight: 400,
                          fontFamily: "'Montserrat', sans-serif",
                          color: textColor
                        }}
                      >
                        Tokens
                      </span>
                      <span
                        style={{
                          fontSize: '16px',
                          fontWeight: 600,
                          fontFamily: "'Montserrat', sans-serif",
                          color: textColor
                        }}
                      >
                        150
                      </span>
                    </Flex>
                  </Flex>
                  <Flex direction="row" className="gap-3">
                    <img
                      src="https://media-dev.appcharge.com/media/booster.png"
                      alt=""
                      style={{
                        width: '48px',
                        height: '48px'
                      }}
                    />
                    <Flex justify="center" className="gap-1">
                      <span
                        style={{
                          fontSize: '12px',
                          fontWeight: 400,
                          fontFamily: "'Montserrat', sans-serif",
                          color: textColor
                        }}
                      >
                        Boosters
                      </span>
                      <span
                        style={{
                          fontSize: '16px',
                          fontWeight: 600,
                          fontFamily: "'Montserrat', sans-serif",
                          color: textColor
                        }}
                      >
                        3
                      </span>
                    </Flex>
                  </Flex>
                  <hr
                    style={{
                      marginBottom: '16px',
                      width: '232px',
                      border: '1px solid white'
                    }}
                  />
                  <Flex className="gap-2.5">
                    <Flex
                      direction="row"
                      justify="between"
                      style={{
                        fontSize: '12px',
                        fontWeight: 400,
                        fontFamily: "'Montserrat', sans-serif",
                        color: textColor
                      }}
                    >
                      <span>Subtotal</span>
                      <span>$ 13.25</span>
                    </Flex>
                    <Flex
                      direction="row"
                      justify="between"
                      style={{
                        fontSize: '12px',
                        fontWeight: 400,
                        fontFamily: "'Montserrat', sans-serif",
                        color: textColor
                      }}
                    >
                      <span>Tax (17%)</span>
                      <span>$ 2.25</span>
                    </Flex>
                    <Flex
                      direction="row"
                      justify="between"
                      style={{
                        fontSize: '16px',
                        fontWeight: 500,
                        fontFamily: "'Montserrat', sans-serif",
                        color: textColor
                      }}
                    >
                      <span>Total</span>
                      <span>$ 15.50</span>
                    </Flex>
                  </Flex>
                </Flex>
              </Flex>
              <Flex
                align="center"
                className="w-full pt-4 relative rounded-r-[15px] bg-[#f4f4f8]"
              >
                <div
                  onClick={() => onClose()}
                  style={{
                    cursor: 'pointer',
                    color: '#000000',
                    width: '25px',
                    height: '25px',
                    position: 'absolute',
                    right: '16px'
                  }}
                >
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    stroke-width="0"
                    viewBox="0 0 512 512"
                    height="25px"
                    width="25px"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z"></path>
                  </svg>
                </div>
                <img
                  src={'./assets/images/checkout_theme_payments.png'}
                  alt="checkout-theme-preview"
                />
                <Flex className="w-full px-12">
                  <Flex
                    justify="center"
                    align="center"
                    className="mt-2 mb-2 w-[90px] h-20 bg-white rounded-lg"
                    style={{
                      borderColor: 'red',
                      border: `1px solid ${buttonColor}`
                    }}
                  >
                    <img
                      src={'./assets/images/checkout_theme_creditcard_box.png'}
                      style={{
                        width: '83px',
                        height: '75px'
                      }}
                      alt="checkout-theme-preview"
                    />
                  </Flex>
                </Flex>
                <img
                  src={'./assets/images/checkout_theme_creditcard.png'}
                  alt="checkout-theme-preview"
                />
                <button
                  style={{
                    width: '349px',
                    background: buttonColor,
                    paddingTop: '12px',
                    paddingBottom: '12px',
                    paddingLeft: '16px',
                    paddingRight: '16px',
                    borderRadius: '4px',
                    border: 0,
                    fontSize: '16px',
                    fontFamily: "'Montserrat', sans-serif",
                    fontWeight: 500,
                    color: buttonTextColor,
                    marginBottom: '8px',
                    marginTop: '8px'
                  }}
                >
                  Pay $ 15.50
                </button>
                <img
                  src={'./assets/images/checkout_theme_footer.png'}
                  alt="checkout-theme-preview"
                />
              </Flex>
            </Flex>
          </Flex>

          <Flex align="center" className="gap-4">
            <Typography variant="h6" color={'white'} fontWeight={400}>
              Mobile
            </Typography>
            <Flex className="w-[340px] h-[860px] bg-[whitesmoke] rounded-[15px] overflow-hidden">
              <Flex
                className="w-full gap-4 px-4 py-4"
                style={{
                  background: primaryColor,
                  backgroundImage: `url(${bgMobileImage !== ''
                    ? bgMobileImage
                    : bgImage !== ''
                      ? bgImage
                      : 'none'
                    })`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center top'
                }}
              >
                <Flex
                  direction="row"
                  justify="between"
                  align="center"
                  className="h-8"
                >
                  <img
                    src={logo}
                    style={{ height: '40px', objectFit: 'contain' }}
                  />
                  <div
                    className="close-button"
                    style={{
                      color: textColor,
                      width: '25px',
                      height: '25px'
                    }}
                  >
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      strokeWidth="0"
                      viewBox="0 0 512 512"
                      height="25px"
                      width="25px"
                      xmlns="http://www.w3.org/2000/svg"
                      style={{ color: textColor }}
                    >
                      <path d="M289.94 256l95-95A24 24 0 00351 127l-95 95-95-95a24 24 0 00-34 34l95 95-95 95a24 24 0 1034 34l95-95 95 95a24 24 0 0034-34z"></path>
                    </svg>
                  </div>
                </Flex>
                <Flex direction="row" justify="between" className="gap-4">
                  <Flex>
                    <Typography
                      variant="h6"
                      color={textColor}
                      m={0}
                      p={0}
                      sx={{
                        fontSize: '16px',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        fontFamily: "'Montserrat', sans-serif"
                      }}
                    >
                      Crazy Pack
                    </Typography>
                    <Typography
                      variant="h6"
                      m={0}
                      p={0}
                      color={textColor}
                      sx={{
                        fontFamily: "'Montserrat', sans-serif",
                        color: textColor,
                        fontSize: '24px',
                        fontWeight: 600,
                        boxSizing: 'border-box',
                        margin: '0px',
                        marginLeft: '2px'
                      }}
                    >
                      $99.99
                    </Typography>
                  </Flex>
                  <Flex
                    direction="row"
                    align="start"
                    justify="center"
                  >
                    <Typography
                      variant="h6"
                      color={textColor}
                      sx={{
                        fontSize: '12px',
                        fontWeight: 400,
                        fontFamily: "'Montserrat', sans-serif"
                      }}
                    >
                      Details{' '}
                      <svg
                        stroke="currentColor"
                        fill="currentColor"
                        stroke-width="0"
                        viewBox="0 0 320 512"
                        height="1em"
                        width="1em"
                        style={{
                          color: textColor,
                          position: 'relative',
                          top: '2px'
                        }}
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M31.3 192h257.3c17.8 0 26.7 21.5 14.1 34.1L174.1 354.8c-7.8 7.8-20.5 7.8-28.3 0L17.2 226.1C4.6 213.5 13.5 192 31.3 192z"></path>
                      </svg>
                    </Typography>
                  </Flex>
                </Flex>
                <hr
                  style={{
                    fontSize: '16px',
                    color: 'white',
                    boxSizing: 'border-box',
                    borderTop: '1px solid #cfcfcf',
                    width: '100%',
                    marginBottom: '0px'
                  }}
                />
                <Flex className="gap-2">
                  <Flex direction="row" justify="between" className="gap-4">
                    <Typography
                      variant="h6"
                      color={textColor}
                      sx={{
                        fontFamily: "'Montserrat', sans-serif",
                        color: textColor,
                        fontSize: '12px',
                        fontWeight: 400,
                        boxSizing: 'border-box'
                      }}
                    >
                      Subtotal
                    </Typography>
                    <Typography
                      variant="h6"
                      color={textColor}
                      sx={{
                        fontFamily: "'Montserrat', sans-serif",
                        color: textColor,
                        fontSize: '12px',
                        fontWeight: 400,
                        boxSizing: 'border-box'
                      }}
                    >
                      $ 13.25
                    </Typography>
                  </Flex>

                  <Flex direction="row" justify="between" className="gap-4">
                    <Typography
                      variant="h6"
                      color={textColor}
                      sx={{
                        fontFamily: "'Montserrat', sans-serif",
                        color: textColor,
                        fontSize: '12px',
                        fontWeight: 400,
                        boxSizing: 'border-box'
                      }}
                    >
                      Tax (17%)
                    </Typography>
                    <Typography
                      variant="h6"
                      color={textColor}
                      sx={{
                        fontFamily: "'Montserrat', sans-serif",
                        color: textColor,
                        fontSize: '12px',
                        fontWeight: 400,
                        boxSizing: 'border-box'
                      }}
                    >
                      $ 2.25
                    </Typography>
                  </Flex>

                  <Flex direction="row" justify="between" className="gap-4">
                    <Typography
                      variant="h6"
                      color={textColor}
                      sx={{
                        color: textColor,
                        fontSize: '1em',
                        fontWeight: 500,
                        boxSizing: 'border-box',
                        fontFamily: "'Montserrat', sans-serif"
                      }}
                    >
                      Total
                    </Typography>
                    <Typography
                      variant="h6"
                      color={textColor}
                      sx={{
                        fontFamily: "'Montserrat', sans-serif",
                        color: textColor,
                        fontSize: '1em',
                        fontWeight: 500,
                        boxSizing: 'border-box'
                      }}
                    >
                      $ 15.50
                    </Typography>
                  </Flex>
                </Flex>
              </Flex>
              <Flex
                align="center"
                className="w-full pt-2 p-2 relative rounded-r-[15px] bg-[#f4f4f8]"
              >
                <img
                  src={'./assets/images/checkout_theme_payments_mobile.png'}
                  style={{ width: '100%' }}
                  alt="checkout-theme-preview"
                />
                <Flex className="w-full">
                  <Flex
                    justify="center"
                    align="center"
                    className="mt-2 mb-2 ml-2 w-[90px] h-20 bg-white rounded-lg"
                    style={{
                      border: `1px solid ${buttonColor}`
                    }}
                  >
                    <img
                      src={'./assets/images/checkout_theme_creditcard_box.png'}
                      style={{
                        width: '83px',
                        height: '75px'
                      }}
                      alt="checkout-theme-preview"
                    />
                  </Flex>
                </Flex>
                <img
                  src={'./assets/images/checkout_theme_creditcard_mobile.png'}
                  style={{ width: '100%' }}
                  alt="checkout-theme-preview"
                />
                <button
                  style={{
                    width: '100%',
                    background: buttonColor,
                    paddingTop: '12px',
                    paddingBottom: '12px',
                    paddingLeft: '16px',
                    paddingRight: '16px',
                    borderRadius: '4px',
                    border: 0,
                    fontSize: '16px',
                    fontFamily: "'Montserrat', sans-serif",
                    fontWeight: 500,
                    color: buttonTextColor,
                    marginBottom: '8px',
                    marginTop: '8px'
                  }}
                >
                  Pay $ 15.50
                </button>
                <img
                  src={'./assets/images/checkout_theme_footer.png'}
                  alt="checkout-theme-preview"
                  style={{ width: '100%' }}
                />
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </Grow>
    </Flex>
  );
};

export default CheckoutThemePreviewV2;
